var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:"sj-icon",class:[("icon-theme-" + _vm.theme), { disabled: _vm.disabled }],style:({
    width: (_vm.size + "px"),
    height: (_vm.size + "px")
  })},_vm.$listeners),[(!_vm.imgSrc)?_c('i',{class:[_vm.fontFamily, _vm.iconClass],style:(_vm.iconStyle)}):_c('img',{style:({ width: (_vm.iconSize + "px"), height: (_vm.iconSize + "px") }),attrs:{"src":_vm.imgSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }